import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {ChartOption} from "./chart-option.component";


/**
 *
 */
@Component({
    selector: "wbo-bi-chart-options",
    templateUrl: "./chart-options.component.html",
    styleUrls: ["./chart-options.component.scss"]
})
export class ChartOptionsComponent implements OnInit, OnChanges {


    @Output() selected: EventEmitter<string> = new EventEmitter<any>();
    @Input() public type: string;

    public options: ChartOption[] = [];



    constructor() {
        this.options.push({icon: "column_chart", type: "column", selected: false});
        this.options.push({icon: "pie_chart", type: "pie", selected: false});
        this.options.push({icon: "donut_chart", type: "donut", selected: false});
        // this.options.push({icon: "stacked_column_chart", type: "column_stacked", selected: false});
        // this.options.push({icon: "stacked_bar_chart", type: "bar_stacked", selected: false});
        this.options.push({icon: "bar_chart", type: "bar", selected: false});
        this.options.push({icon: "area_chart", type: "area", selected: false});
        this.options.push({icon: "line_chart", type: "line", selected: false});
        this.options.push({icon: "spline_chart", type: "spline", selected: false});
        this.options.push({icon: "area_spline_chart", type: "areaspline", selected: false});
        this.options.push({icon: "grid", type: "grid", selected: false});
        this.options.push({icon: "sum", type: "summary", selected: false});
    }

    ngOnInit(): void {
        this.updateSelected();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateSelected();
    }

    public selectOption(option: ChartOption): void {
        this.selected.next(option.type);
    }

    private updateSelected(): void {
        this.options.forEach((o: ChartOption) => o.type === this.type ? o.selected = true : o.selected = false);
    }





}
